import styles from './NotificationsSettingsDialog.module.css'
import { Dialog } from '@mui/material'
import { NotificationsSettingsFormUpdate } from '../NotificationsSettingsFormUpdate'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { selectNotificationsSettingsDialogOpen, setNotificationsSettingsDialogOpen } from 'store/applicationSlice'
import { CloseButton } from './CloseButton'
import { Drawer } from 'shared/ui/strspykit/Drawer'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'


interface NotificationsSettingsDialogProps {
    open?: boolean
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
}

export const NotificationsSettingsDialog = (props: NotificationsSettingsDialogProps) => {
    const {
        open,
        onOpen,
        onClose
    } = props

    const notificationsSettingsDialogOpen = useAppSelector(selectNotificationsSettingsDialogOpen)
    const dispatch = useAppDispatch()
    const isMediumScreenOrMore = useBreakpointUp('xl')

    const handleCloseButtonClick = () => {
        dispatch(setNotificationsSettingsDialogOpen(false))
    }

    const handleDialogClose = (event: any, reason: any) => {
        dispatch(setNotificationsSettingsDialogOpen(false))
    }

    const handleDrawerClose = (event: any) => {
          dispatch(setNotificationsSettingsDialogOpen(false))
    }

    const handleNotificationsSettingsFormUpdateUpdateCompleted = () => {
        dispatch(setNotificationsSettingsDialogOpen(false))
    }

    const handleDialogClick = (event: any) => {
        event.stopPropagation()
    }

    const handleFollowLink = (event: any) => {
        dispatch(setNotificationsSettingsDialogOpen(false))
    }

    if (isMediumScreenOrMore) {
        return (
            
           <Dialog
                className={styles.NotificationsSettingsDialog}
                open={notificationsSettingsDialogOpen}
                onClose={handleDialogClose}
                onClick={handleDialogClick}
            >
                <div className={styles.NotificationsSettingsDialog__ContentContainer}>
                    <div className={styles.NotificationsSettingsDialog__StartContainer}>
                        <div className={styles.NotificationsSettingsDialog__StartToolbar}>
                            <div></div>
                            <span className={styles.NotificationsSettingsDialog__Heading1}>Notifications Settings</span>
                            <div className={styles.NotificationsSettingsDialog__StartToolbarEndContainer}>
                                <CloseButton
                                    onClick={handleCloseButtonClick}
                                />
                            </div>
                        </div>
                        <hr className={styles.NotificationsSettingsDialog__Divider} />
                    </div>
                    <div className={styles.NotificationsSettingsDialog__CenterContainer}>
                        <NotificationsSettingsFormUpdate 
                            onUpdateCompleted={handleNotificationsSettingsFormUpdateUpdateCompleted}
                            onFollowLink={handleFollowLink}
                        />
                    </div>
                </div>        
            </Dialog>
        )
    }

       return (
            <Drawer
                open={notificationsSettingsDialogOpen}
                onClose={handleDrawerClose}
            >
                <div>
                    <div className={styles.NotificationsSettingsDialog__StartContainer}>
                        <div className={styles.NotificationsSettingsDialog__StartToolbar}>
                            <div></div>
                            <span className={styles.NotificationsSettingsDialog__Heading1}>Notifications Settings</span>
                            <div className={styles.NotificationsSettingsDialog__StartToolbarEndContainer}>
                                <CloseButton
                                    onClick={handleCloseButtonClick}
                                />
                            </div>
                        </div>
                        <hr className={styles.NotificationsSettingsDialog__DrawerDivider} />
                    </div>
                    <div className={styles.NotificationsSettingsDialog__DrawerCenterContainer}>
                        <NotificationsSettingsFormUpdate 
                            onUpdateCompleted={handleNotificationsSettingsFormUpdateUpdateCompleted}
                        />
                    </div>
                </div>     
            </Drawer>
        )
}